import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtCyodPopupCtrl($scope, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.digitalPackgeList = $scope.packageList;

  this.goToDetail = function (skuCode) {
    $scope.selectClick({ skuCode: skuCode });
  };
}

App.controller('LtCyodPopupCtrl', ['$scope', '$timeout', LtCyodPopupCtrl]);
